import request from "./request";

const menu = {
  postLogin(params) {
    return request({
      method: "POST",
      url: "/login-center/merchant/pc/login",
      data: params,
    });
  },
  logout(params) {
    return request({
      method: "POST",
      url: "/login-center/merchant/pc/logout",
      data: params,
    });
  },
  // 差异订单列表
  aprList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/apr/list",
      data: params,
    });
  },
  // 追差分类列表
  catalogList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/apr/catalog/list",
      data: params,
    });
  },
  // 差异订单详情
  aprDetail(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/apr/detail",
      data: params,
    });
  },
  //审核详情
  auditInfo(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/apr/auditInfo",
      data: params,
    });
  },
  //撤回追差
  aprCancel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/apr/cancel",
      data: params,
    });
  },
  //差异订单导出Excel
  aprExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/apr/excel",
      data: params,
      responseType: "blob",
    });
  },
  //Q-导出报价单Excel
  baoExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/quote-list-excel",
      data: params,
      responseType: "blob",
    });
  },
  // 订单详情
  orderInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/info",
      params: params,
    });
  },

  // Q-撤销收货详情
  findCancelReceiptInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/findCancelReceiptInfo",
      params,
    });
  },
  // Q-机况分类列表
  getHealthList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/getHealthList",
      params,
    });
  },
  // Q-获取测算配置
  lantingconfiguration(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/indicative/lt/configuration",
      params,
    });
  },

  // 验机报告-功能情况
  getInspectionReport(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/getInspectionReport",
      params: params,
    });
  },
  // 追差分类详情
  catalogInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/apr/catalog/info",
      params: params,
    });
  },
  // 获取验证码
  sendCode(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/center/sendCode",
      params: params,
    });
  },
  // 重置密码
  resetPwd(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/center/resetPwd",
      data: params,
    });
  },
  ///////////////////////////////////////////系统管理
  //角色列表
  RoleList(params = {}) {
    return request({
      method: "POST",
      url: "/merchant/pc/role/list",
      data: params,
    });
  },
  //角色详情
  RoleInfoRes(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/role/info",
      params: params,
    });
  },
  //角色编辑
  RoleEdit(params = {}) {
    return request({
      method: "POST",
      url: "/merchant/pc/role/edit",
      data: params,
    });
  },
  //角色添加
  roleAdd(params = {}) {
    return request({
      method: "POST",
      url: "/merchant/pc/role/add",
      data: params,
    });
  },
  // 角色菜单
  getMenuList(params = {}) {
    return request({
      method: "GET",
      url: "/merchant/pc/role/menu",
      params: params,
    });
  },
  //职员列表
  getWorkerList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/staffList",
      data: params,
    });
  },
  //获取账户信息
  getStaffAccount(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/getStaffAccount",
      params: params,
    });
  },
  //生成职员账号
  createPcAcc(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/createPcAcc",
      params: params,
    });
  },
  //角色下拉列表
  roleSelectByRole(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/roleSelectByRole",
      params: params,
    });
  },
  //旧机分类下拉列表
  oldMachineTypeList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/oldMachineType/selectList",
      params: params,
    });
  },
  //保存后台账号
  savePcStaff(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/savePcStaff",
      data: params,
    });
  },
  //保存小程序账号
  saveXcxStaff(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/saveXcxStaff",
      data: params,
    });
  },
  //重置密码
  resetStaffPwd(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/resetStaffPwd",
      params: params,
    });
  },
  //删除角色
  removeStaff(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/removeStaff",
      params: params,
    });
  },
  //离职
  updateIsQuit(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/updateIsQuit",
      params: params,
    });
  },
  //是否启用
  updateWorkerIsEnable(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/updateIsEnable",
      params: params,
    });
  },
  // 报价修改信息列表
  getUpdatedQuoteLog(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/getUpdatedQuoteLog",
      params: params,
    });
  },
  // 导入职员
  importXcxStaff(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/inputXcxStaff",
      data: params,
    });
  },
  // 调拨店员
  allot(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/allot",
      data: params,
    });
  },
  ///////////////////////////////////////////回收订单
  orderList(params = {}) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/list",
      data: params,
    });
  },
  //隐藏ID-获取订单信息
  hideIdgetOrderInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/hideid/getOrderInfo",
      params,
    });
  },
  // 导出Excel
  orderExcel(params = {}) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/excel",
      data: params,
      responseType: "blob",
    });
  },
  exportExcel(params = {}) {
    return request({
      method: "POST",
      url: "/merchant/pc/account/detail/exportExcel",
      data: params,
      responseType: "blob",
    });
  },
  billExportExcel(params = {}) {
    return request({
      method: "POST",
      url: "/merchant/pc/account/detail/exportExcel",
      data: params,
      responseType: "blob",
    });
  },
  // 获取动态
  orderFlow(params = {}) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/orderFlow",
      params: params,
    });
  },
  ///////////////////////////////////////////第三方回收商
  // 已绑定从账号
  getSubStaffs(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/subStaffs",
      params,
    });
  },
  // 从账号操作
  operateSubStaff(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/operateSubStaff",
      data: params,
    });
  },

  // 获取个性化配置
  // /merchant/pc/config/getCompanyCustomConfig
  getCompanyCustomConfig(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/config/getCompanyCustomConfig",
      data: params,
    });
  },

  // 设置个性化配置
  setCompanyCustomConfig(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/config/setCompanyCustomConfig",
      data: params,
    });
  },
  excelexpressorder(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/express/order/excel",
      data: params,
      responseType: "blob",
    });
  },
  // getOrderListByExpressNo
  getOrderListByExpressNo(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/express/order/getOrderListByExpressNo",
      data: params,
    });
  },

  //支付配置详情
  configInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/config/configInfo",
      params,
    });
  },
  ///////////////////////////////////////////快递收货

  // 物流订单强制取消
  cancelForceOrder(params) {
    return request.post("/platform/pc/express/order/cancelForce", params);
  },
  // 强制取消详情
  getCancelForceInfo(expressNo) {
    return request.get(
      `/platform/pc/express/order/getCancelForceInfo?expressNo=${expressNo}`
    );
  },
  // 物流订单对应的回收订单
  recycleOrder(params) {
    return request.post("/platform/pc/express/order/recycleOrder", params);
  },
  // 查询快递列表
  getExpressOrders(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/express/order/getExpressOrders",
      data: params,
    });
  },
  // 取消寄件
  expressOrderCancel(params) {
    return request({
      method: "GET",
      url: "/platform/pc/express/order/cancel",
      params,
    });
  },
  //收件列表
  getReceiveList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/receive/list",
      data: params,
    });
  },
  // 快递详情
  logisticsInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/receive/logisticsInfo",
      params,
    });
  },

  // 分转后快递详情
  trackLogisticsInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/machine/track/logisticsInfo",
      params,
    });
  },

  // 物流信息
  getLogisticsInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/express/order/logisticsInfo",
      params,
    });
  },
  // 导出收件列表
  receiveExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/receive/excel",
      data: params,
      responseType: "blob",
    });
  },
  // 创建收件
  addReceive(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/receive/addReceive",
      data: params,
    });
  },
  // 批次号的收件快递明细/查看异常出件
  allReceiveList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/receive/detail/list",
      data: params,
    });
  },
  //标记异常出件
  courierNumber(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/receive/tag/courierNumber",
      params: params,
    });
  },
  //查询关联订单
  findOrder(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/receive/findOrder",
      data: params,
    });
  },
  //核对快件
  checkCourier(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/receive/check/courierNumber",
      params: params,
    });
  },
  //职员列表（下拉列表）
  operatorSelect(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/staffSimpleList",
      data: params,
    });
  },
  // Q-非最高报价订单
  qfaOrderList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/qfa/qfaOrderList",
      data: params,
    });
  },
  // Q-Q-机型名称统计
  phoneNameStatistics(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/qfa/phoneNameStatistics",
      data: params,
    });
  },
  //Q-规格统计
  skuStatistics(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/qfa/skuStatistics",
      data: params,
    });
  },
  //Q-标签统计
  biaoqiananalyse(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/qfa/tagStatistics",
      data: params,
    });
  },
  //Q-采集订单明细
  CollectionorderList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/qfa/orderList",
      data: params,
    });
  },
  // Q-非最高报价订单（导表
  qfaOrderListExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/qfa/qfaOrderListExcel",
      data: params,
      responseType: "blob",
    });
  },
  // Q-非最高报价订单修改成色等级
  updateHealthCodeCus(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/qfa/updateHealthCodeCus",
      data: params,
    });
  },
  //获取订单信息
  findOrderDetail(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/findOrder",
      data: params,
    });
  },
  //导入收货数据
  importConsigneedata(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/import",
      data: params,
    });
  },
  //账单列表
  getAccountPayList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/account/detail/getList",
      data: params,
    });
  },
  //收货详情
  getSerTypeList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/account/detail/getSerTypeList",
      params: params,
    });
  },
  // Q-核对账单信息
  findApprovedUpDownInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/account/detail/findApprovedUpDownInfo",
      params: params,
    });
  },
  // 核账
  accountDetailApproved(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/account/detail/approved",
      data: params,
    });
  },
  // 核账记录
  getApprovedLogList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/account/detail/getApprovedLogList",
      data: params,
    });
  },
  //保存导入数据
  saveConsignedata(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/save",
      data: params,
    });
  },
  //确认收货
  suretakeDelivery(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/takeDelivery",
      data: params,
    });
  },
  //收货详情
  receivingdetail(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/machine/take/detail",
      params: params,
    });
  },
  // 收件记录 导出全部明细
  reportExcelAll(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/excelAll",
      data: params,
      responseType: "blob",
    });
  },
  // 收件记录 导出收货明细
  reportconsigExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/excel",
      data: params,
      responseType: "blob",
    });
  },
  //收货列表
  batchDetailList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/batchDetailList",
      data: params,
    });
  },
  //收货记录批次列表
  batchList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/take/batchList",
      data: params,
    });
  },
  // ================== 收货订单管理 ================== //
  // 分转收货列表
  dptmList(params) {
    return request.post("/merchant/pc/machine/track/list", params);
  },

  // 门店商家下拉列表
  getSelectList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/company/getAllMiddleAdoptCompany",
      params: params,
    });
  },
  // Q-主、从账户商户下拉列表
  getmastermerchantSelectList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/account/detail/get-master-salve-select-list",
      params: params,
    });
  },
  // 商品分类
  selectTypeList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/selectTypeList",
      params: params,
    });
  },
  // 品牌下拉列表
  selectBrandList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/selectBrandList",
      params: params,
    });
  },
  // 下单门店下拉
  getStoreSelectList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/company/getStoreSelectList",
      params: params,
    });
  },
  // 已收到货
  takeDeliverGoods(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/track/takeDeliverGoods",
      data: params,
    });
  },

  // 上报异常
  upErrorTrack(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/error/track/upErrorTrack",
      params,
    });
  },

  // 导出分货表
  dptmExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/machine/track/excel",
      data: params,
      responseType: "blob",
    });
  },
  // ====异常到货跟踪
  getErrorTrackList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/error/track/getList",
      data: params,
    });
  },
  // 导出分货表
  dptmErrorExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/error/track/excel",
      data: params,
      responseType: "blob",
    });
  },
  // 异常催货-已收到货
  doReceived(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/error/track/doReceived",
      params,
    });
  },

  // 跟进记录
  getFollow(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/error/track/getFollow",
      params,
    });
  },
  //往来单位管理
  //供应商下拉框(全部)
  supplierSelect(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/supplier/select/pull/down",
      params: params,
    });
  },
  //供应商列表
  supplierList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/supplier/list",
      data: params,
    });
  },
  // 添加-修改 备注
  saveRemark(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/supplier/saveRemark",
      data: params,
    });
  },
  //添加-修改 往来单位
  supplierAddOrUpdate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/supplier/addOrUpdate",
      data: params,
    });
  },
  //供应商启用或禁用
  supplierOpenOrClose(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/supplier/openOrClose",
      params: params,
    });
  },
  // 入库自动收货
  enableAutoDelivery(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/supplier/enableAutoDelivery",
      data: params,
    });
  },
  // 单据详情
  //供应商下拉框(入库单位)
  supplierIntoSelect(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/supplier/into/pull/down",
      params: params,
    });
  },
  //入库单据列表
  warehouseList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/warehouse/into/list",
      data: params,
    });
  },
  // Q-打印串号查询
  getPrintImeiInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/warehouse/into/getPrintImeiInfo",
      params: params,
    });
  },
  // 导出-入库单据
  warehouseExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/warehouse/into/excel",
      data: params,
      responseType: "blob",
    });
  },
  // =====旧机入库
  // 查询订单
  warehouseFindOrder(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/warehouse/into/findOrder",
      data: params,
    });
  },
  // 更新入库单据
  warehouseIntoUpdate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/warehouse/into/update",
      data: params,
    });
  },
  // 串号跟踪列表,判断是否有重复
  imeiTrack(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/imei/track/list",
      params: params,
    });
  },
  // 生成入库单据
  warehouseIntoBuild(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/warehouse/into/build",
      data: params,
    });
  },
  // 入库单据详情
  warehouseInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/warehouse/into/info",
      params: params,
    });
  },
  // 仓库下拉框
  warehouseSelect(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/warehouse/pull/down",
      params: params,
    });
  },
  // -查看快捷备注
  getFastNote(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/fast/note/get",
      params: params,
    });
  },
  // ==== 出库管理
  // 获取配置
  // getErpconfig(params) {
  //     return request({
  //         method: 'GET',
  //         url: '/merchant/pc/config/get',
  //         params,
  //     })
  // },
  //导入已出库订单（仅支持.xls及.xlsx格式）
  importImei(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/warehouse/out/importImei",
      data: params,
    });
  },
  //-报价单列表
  merchantQuoteList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/quote-list",
      data: params,
    });
  },
  // 购买人/收货人/查询人  列表
  recycleStaffSelect(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/recycleStaffSelect",
      params,
    });
  },
  // 修改密码
  assignStaffAcc(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/assignStaffAcc",
      data: params,
    });
  },
  // 获取验证码
  staffSendCode(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/staff/sendCode",
      params: params,
    });
  },
  // 忘记密码
  forgetPwd(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/staff/forgetPwd",
      data: params,
    });
  },
  // -机型下拉列表
  listMachineSelected(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/listMachineSelected",
      data: params,
    });
  },
  // 充值订单列表
  getPayList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/take/bill/getMerchantRechargeOrderList",
      data: params,
    });
  },
  // 使用记录列表
  getMerchantUsedLog(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/take/bill/getMerchantUsedLog",
      data: params,
    });
  },
  // 撮合交易账单列表
  matchOrderDetail(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/take/bill/matchOrderDetail",
      data: params,
    });
  },
  // Q-导出退回-收货使用-绑码使用-苹果锁-串号查询-下账明细
  excelOther(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/take/bill/excelOther",
      data: params,
      responseType: "blob",
    });
  },
  // Q-导出撮合扣款明细
  excelMatch(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/take/bill/excelMatch",
      data: params,
      responseType: "blob",
    });
  },
  // Q-导出充值明细
  excelRecharge(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/take/bill/excelRecharge",
      data: params,
      responseType: "blob",
    });
  },
  // 报价审单
  // 获取机型模版名称下拉列表
  getExamineMachineTemplateList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineTemplateList",
      params,
    });
  },
  // 获取机型模版信息
  getExamineMachineTemplateInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineTemplateInfo",
      params,
    });
  },
  // 保存机型模版信息
  saveExamineMachineTemplate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/saveMachineTemplate",
      data: params,
    });
  },
  // 删除模版
  removeExamineMachineTemplate(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/removeMachineTemplate",
      params,
    });
  },
  // 品牌下拉列表
  getExamineSelectBrandList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/selectBrandList",
      params,
    });
  },
  // 机型下拉列表
  getExamineMachineSelected(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/listMachineSelected",
      data: params,
    });
  },
  // 获取机型容量列表
  getExamineMachineCapacityList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineCapacityList",
      params,
    });
  },
  // 通用内存运存
  getExamineMachineSpec(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineSpec",
      params,
    });
  },
  // 保存机型
  saveExamineMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/saveMachine",
      data: params,
    });
  },
  // 机型出货价配置删除机型
  deleteMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/deleteMachine",
      data: params,
    });
  },
  // 机型-Q-获取机型列表
  getExamineMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getMachineList",
      data: params,
    });
  },
  // 机型-Q-获取机型规格列表
  getMachineMachineSkuList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getMachineSkuList",
      data: params,
    });
  },
  // 机型-Q-获取机型详情
  getExamineMachineInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineInfo",
      params,
    });
  },
  // 机型-更新出货价
  updateExamineMachineSkuPrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/updateMachineSkuPrice",
      data: params,
    });
  },
  // 机型-启用禁用
  examineEnableMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/enableMachine",
      data: params,
    });
  },
  // 导入-出货价
  importExamineMachineSkuPrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/import-machine-sku-price",
      data: params,
    });
  },
  // 导入-扣减项
  importExamineMachinemMchineDeductPrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/import-machine-delivery-adjust",
      data: params,
    });
  },
  // 导入-导入记录
  importExamineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getImportList",
      data: params,
    });
  },
  // 机型-Q-机型出货价启用状态数量
  getMachineEnableNum(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineEnableNum",
      params,
    });
  },
  // 平台热门询价机型
  findInquiryInBrandRank(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/findInquiryInBrandRank",
      params,
    });
  },
  // Q-导出品牌下机型容量信息
  excelFxMachineByBrand(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/excelFxMachineByBrand",
      params,
      responseType: "blob",
    });
  },
  // 保存机型模板信息
  channelfeeSaveTemplate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/saveTemplate",
      data: params,
    });
  },
  // Q-获取模板列表
  getChannelfeeTemplateList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/getTemplateList",
      data: params,
    });
  },
  // Q-获取商家列表
  getChannelfeeCompanyList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/getCompanyList",
      data: params,
    });
  },
  // Q-获取模板信息
  getChannelfeeTemplateInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/channelfee/geTemplateInfo",
      params,
    });
  },
  // Q-处理商家（添加，移除）
  channelfeeHandlerCompany(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/handlerCompany",
      data: params,
    });
  },
  // 移除模版
  channelfeeRemoveTemplate(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/channelfee/removeTemplate",
      params,
    });
  },
  // 导入-Q-导入记录-出货价
  getChannelfeeImportListSku(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getImportListSku",
      params,
    });
  },
  // Q-获取机型询价量（过去7日）
  getMachineOrderNum(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineOrderNum",
      params,
    });
  },
  // 机型-移除机型规格
  removeExamineMachineSku(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/removeMachineSku",
      params,
    });
  },
  // 可通过品牌查询询价机型排行次数
  canInquiryInBrandRankTimes(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/canInquiryInBrandRankTimes",
      params,
    });
  },
  // Q-机型改价
  updatelantingPrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/indicative/lt/updatePrice",
      data: params,
    });
  },
  // 审单人员配置
  // Q-获取审单人员列表
  getExamineUserList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/getUserList",
      data: params,
    });
  },
  // Q-保存审单人员
  saveExamineUser(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/saveUser",
      data: params,
    });
  },
  // Q-获取审单人员详情
  getExamineUserInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/user/getUserInfo",
      params,
    });
  },
  // 兰亭参考价权限
  getlantinghasPermission(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/indicative/lt/hasPermission",
      params,
    });
  },
  // Q-审单员下拉列表
  getExaminePcStaffList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/user/pcStaffList",
      params,
    });
  },
  // Q-获取商家列表（新增编辑）
  getUserCompanyAddEditList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/getUserCompanyList-save",
      data: params,
    });
  },
  // Q-获取商家列表
  getExamineUserCompanyList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/getUserCompanyList",
      data: params,
    });
  },
  // Q-处理商家（添加，移除）
  examineHandlerUserCompany(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/handlerUserCompany",
      data: params,
    });
  },
  // Q-报价师同时报价设置-门店商列表
  getMiddleCompanyTogetherList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/getMiddleCompanyTogetherList",
      data: params,
    });
  },
  // Q-报价师同时报价设置
  setMiddleCompanyTogether(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/setMiddleCompanyTogether",
      data: params,
    });
  },
  // Q-审单-启用禁用
  examineEnableUser(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/enableUser",
      data: params,
    });
  },
  // Q-机况下拉列表
  healthSelectList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/user/healthSelectList",
      params,
    });
  },

  //审单订单
  // 待审核-首页统计
  examineWaitHomeStatistics(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/waitHomeStatistics",
      params,
    });
  },
  // Q-抢下一单
  examineGrabNext(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/grabNext",
      data: params,
    });
  },
  // 订单详情（待审单）
  merchantInfoOrder(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/infoOrder",
      params,
    });
  },
  // Q-获取登录用户可审单机型列表
  getUserMachineSelected(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/getUserMachineSelected",
      data: params,
    });
  },
  // Q-审单区（审核参数）
  getExamineMachineOption(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/getExamineMachineOption",
      data: params,
    });
  },
  // Q-订单详情（统计）
  orderInfoStatistics(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/orderInfoStatistics",
      params,
    });
  },
  // Q-今日已审订单
  getMyTodayExamineOrderList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/getMyTodayExamineOrderList",
      data: params,
    });
  },
  // Q-审单确认
  ackExamineQuote(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/ackExamineQuote",
      data: params,
    });
  },
  // Q-获取合并图片
  getMergeImg(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/mergeImg",
      params,
    });
  },
  // 标记补拍信息知道了
  gotOnceAgainImg(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/gotOnceAgainImg",
      params,
    });
  },
  // 标记重新补拍信息（已读）
  readOnceAgainImg(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/readOnceAgainImg",
      params,
    });
  },
  // 退出审单
  examineSignOut(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/signOut",
      params,
    });
  },
  // Q-转单给报价师
  transferToWechat(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/transferToWechat",
      data: params,
    });
  },
  // 转单给审单组长
  transferToExamineLeader(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/transferToExamineLeader",
      data: params,
    });
  },
  // Q-申请补拍照片
  applyOnceAgainPhoto(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/applyOnceAgainPhoto",
      data: params,
    });
  },
  // Q-审核详情
  getExamineInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/getExamineInfo",
      params,
    });
  },
  // Q-报低价判断
  getLimitationLowPrice(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/getLimitationLowPrice",
      params,
    });
  },
  // Q-获取参考价信息
  getReferenceprice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/reference_price/get",
      data: params,
    });
  },
  // Q-重新报价
  reAckExamineQuote(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/reAckExamineQuote",
      data: params,
    });
  },
  // Q-取消抢单(报价)
  grabCancel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/grabCancel",
      data: params,
    });
  },
  // Q-开始接单了上线
  signOn(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/signOn",
      params,
    });
  },
  // Q-强制下线
  forcedOffline(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/user/forcedOffline",
      params,
    });
  },
  // Q-在线状态查询
  signState(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/signState",
      params,
    });
  },
  // Q-已审订单
  getExamineOrderList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/getExamineOrderList",
      data: params,
    });
  },
  // Q-导出Excel已审订单
  getExamineOrderExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/getExamineOrderExcel",
      data: params,
      responseType: "blob",
    });
  },
  // Q-金额明细
  // getExamineDeductList(params) {
  //     return request({
  //         method: 'GET',
  //         url: '/merchant/pc/examine/quote/order/getExamineDeductList',
  //         params,
  //     })
  // },

  // 出货价增减项-Q-获取分类列表
  getDeliveryAdjustClassifyList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getDeliveryAdjustClassifyList",
      params,
    });
  },
  // 出货价增减项-Q-获取项列表
  getDeliveryAdjustOptionList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getDeliveryAdjustOptionList",
      params,
    });
  },
  // 出货价增减项-Q-查看金额列表
  getDeliveryAdjustOptionPriceList(params) {
    return request({
      method: "GET",
      url:
        "/merchant/pc/examine/quote/machine/getDeliveryAdjustOptionPriceList",
      params,
    });
  },
  // 出货价增减项-保存项
  saveDeliveryAdjustOption(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/saveDeliveryAdjustOption",
      data: params,
    });
  },
  // 出货价增减项-保存金额
  saveDeliveryAdjustOptionPrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/saveDeliveryAdjustOptionPrice",
      data: params,
    });
  },
  // 出货价增减项-Q-删除金额
  removeDeliveryAdjustOptionPrice(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/removeDeliveryAdjustOptionPrice",
      params,
    });
  },
  // 出货价增减项-移除项
  removeDeliveryAdjustOption(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/removeDeliveryAdjustOption",
      data: params,
    });
  },
  // 出货价增减项-移除项
  useDeliveryAdjustClassify(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/useDeliveryAdjustClassify",
      data: params,
    });
  },
  // 出货价增减项-Q-查看机型列表
  getDeliveryAdjustOptionPriceMachineList(params) {
    return request({
      method: "POST",
      url:
        "/merchant/pc/examine/quote/machine/getDeliveryAdjustOptionPriceMachineList",
      data: params,
    });
  },
  // 出货价增减项-Q-查看机型列表
  getReserveDiffAdjustOptionPriceMachineList(params) {
    return request({
      method: "POST",
      url:
        "/merchant/pc/examine/quote/machine/getReserveDiffAdjustOptionPriceMachineList",
      data: params,
    });
  },
  // 出货价增减项-预扣差异-保存金额关联机型
  saveReserveDiffAdjustOptionPriceMachine(params) {
    return request({
      method: "POST",
      url:
        "/merchant/pc/examine/quote/machine/saveReserveDiffAdjustOptionPriceMachine",
      data: params,
    });
  },
  // 出货价增减项-预扣差异-移除金额关联机型
  removeReserveDiffAdjustOptionPriceMachine(params) {
    return request({
      method: "POST",
      url:
        "/merchant/pc/examine/quote/machine/removeReserveDiffAdjustOptionPriceMachine",
      data: params,
    });
  },
  // 出货价增减项-预扣差异-删除金额
  removeReserveDiffAdjustOptionPrice(params) {
    return request({
      method: "GET",
      url:
        "/merchant/pc/examine/quote/machine/removeReserveDiffAdjustOptionPrice",
      params,
    });
  },
  // 出货价增减项-保存金额关联机型
  saveDeliveryAdjustOptionPriceMachine(params) {
    return request({
      method: "POST",
      url:
        "/merchant/pc/examine/quote/machine/saveDeliveryAdjustOptionPriceMachine",
      data: params,
    });
  },
  // 出货价增减项-移除金额关联机型
  removeDeliveryAdjustOptionPriceMachine(params) {
    return request({
      method: "POST",
      url:
        "/merchant/pc/examine/quote/machine/removeDeliveryAdjustOptionPriceMachine",
      data: params,
    });
  },
  // 导入-获取出货价表头
  getMachineSkuPriceExcelHeader(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getMachineSkuPriceExcelHeader",
      params,
      responseType: "blob",
    });
  },
  // 导入-Q-导入记录-出货价增减项
  getImportListDeliveryAdjust(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getImportListDeliveryAdjust",
      params,
    });
  },
  // Q-获取下级机况列表
  getChildHealthList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getChildHealthList",
      params,
    });
  },
  // Q-导出审单机型Excel
  getExamineMachineExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getExamineMachineExcel",
      data: params,
      responseType: "blob",
    });
  },
  // Q-参考价数据导出
  getindicativeExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/indicative/download",
      data: params,
      responseType: "blob",
    });
  },
  // Q-审单机型平台下载链接
  getExamineMachineDownloadUrl(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getExamineMachineDownloadUrl",
      params,
    });
  },
  // Q-串号配置查询
  getDetectionCategoryConfig(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/imei/detection/category/getDetectionCategoryConfig",
      params,
    });
  },
  // Q-串号查询类目
  getAllDetectionCategory(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/imei/detection/category/getAllDetectionCategory",
      params,
    });
  },
  // Q-串号配置启用禁用
  enableDetectionCategory(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/imei/detection/category/enableDetectionCategory",
      data: params,
    });
  },
  // Q-进行串号查询
  doDetection(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/imei/detection/category/doDetection",
      data: params,
    });
  },
  // Q-进行串号查询
  categoryList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/imei/detection/category/list",
      data: params,
    });
  },
  // 获取查询类目
  getDetectionCategory(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/imei/detection/category/getDetectionCategory",
      params: params,
    });
  },
  // Q-串号查询信息
  findIMEILatest(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/imei/detection/category/findIMEILatest",
      params: params,
    });
  },
  // 获取查询类目
  queryResults(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/imei/detection/category/queryResults",
      params: params,
    });
  },
  // 平台机型示例图
  getExamineQuoteMachineSamplePicture(params) {
    return request({
      method: "GET",
      url:
        "/merchant/pc/examine/quote/order/getExamineQuoteMachineSamplePicture",
      params: params,
    });
  },
  // Q-获取配置
  getConfigInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/getConfigInfo",
      params,
    });
  },
  // 切换审单设置
  changeExamineMode(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/changeExamineMode",
      data: params,
    });
  },
  // Q-报价金额计算
  examineComputePrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/examineComputePrice",
      data: params,
    });
  },
  // Q-获取模版内添加机型列表
  getUnAddMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/getUnAddMachineList",
      data: params,
    });
  },
  // Q-获取下级机况列表（平铺）
  getChildHealthListTile(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getChildHealthListTile",
      params,
    });
  },
  // Q-获取下级机况列表（平铺）过滤
  getChildHealthListTileFilter(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getChildHealthListTileFilter",
      data: params,
    });
  },
  // 机型-Q-获取机型下拉列表
  getMachineSelectList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getMachineSelectList",
      data: params,
    });
  },
  // 机型-Q获取机型容量列表
  getExamineredfdMachineCapacityList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/getExamineMachineCapacityList",
      params,
    });
  },
  // 报价分析-折线统计
  findQuoteAnalysisFoldLine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/statistic/findQuoteAnalysisFoldLine",
      data: params,
    });
  },
  // Q-获取商家列表(新增编辑)
  getCompanyListAdd(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/getCompanyListAdd",
      data: params,
    });
  },
  // Q-审单数据-审单统计
  findStatisticData(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/statistic/findStatisticData",
      data: params,
    });
  },
  // Q-审单数据-业绩排行
  findRankListData(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/statistic/findRankListData",
      data: params,
    });
  },
  // 审单数据-业绩排行-导出
  excelRankListData(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/statistic/excelRankListData",
      data: params,
      responseType: "blob",
    });
  },
  // 审单数据-详细数据-导出
  excelRankMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/statistic/excelRankMachineList",
      data: params,
      responseType: "blob",
    });
  },
  // Q-审单数据-详细数据
  findRankMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/statistic/findRankMachineList",
      data: params,
    });
  },
  // Q-出货价增减项-Q-获取管理列表
  getOptionAssignHealthList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getOptionAssignHealthList",
      data: params,
    });
  },
  // Q-出货价增减项-编辑项
  updateDeliveryAdjustOption(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/updateDeliveryAdjustOption",
      data: params,
    });
  },
  // Q-出货价增减项-指定成色修改
  saveAdjustOptionAssignHealth(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/saveAdjustOptionAssignHealth",
      data: params,
    });
  },
  // Q-出货价增减项-修改排序
  updateAdjustOptionSort(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/updateAdjustOptionSort",
      params,
    });
  },
  // Q-出货价增减项-指定成色修改
  setOrderFilterSeconds(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/setOrderFilterSeconds",
      data: params,
    });
  },
  // Q-报价金额可见权限是否开启
  setIsOpenExamineShowQuotePrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/setIsOpenExamineShowQuotePrice",
      data: params,
    });
  },
  // Q-报价调整权限是否开启
  setIsOpenExamineAlterQuotePrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/setIsOpenExamineAlterQuotePrice",
      data: params,
    });
  },
  // Q-保存报价调整上限设置
  setUpdateUserAlterConfig(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/setUpdateUserAlterConfig",
      data: params,
    });
  },
  // Q-报价调整上限设置
  getUpdateUserAlterConfig(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/user/getUpdateUserAlterConfig",
      params,
    });
  },
  // Q-新增机型模板信息
  addTemplate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/addTemplate",
      data: params,
    });
  },
  // Q-编辑机型模板信息
  editTemplate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/channelfee/editTemplate",
      data: params,
    });
  },
  // Q-改价日志
  getChangePriceLogs(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getChangePriceLogs",
      data: params,
    });
  },
  // Q-获取渠道模板下拉列表
  getTemplateSelectList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/channelfee/getTemplateSelectList",
      params,
    });
  },
  // 机型-Q-获取机型规格预估价列表
  getMachineSkuPrePriceList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getMachineSkuPrePriceList",
      data: params,
    });
  },

  //监控报价管理
  //模板-Q-查看任务列表
  getTaskList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/monitor/task/getTaskList",
      params,
    });
  },
  // 新建立任务
  addTask(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/addTask",
      data: params,
    });
  },
  // 修改任务
  updateTask(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/updateTask",
      data: params,
    });
  },
  //Q-查看任务详情
  getTaskInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/monitor/task/getTaskInfo",
      params,
    });
  },
  // 创建区间
  addTaskRegion(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/addTaskRegion",
      data: params,
    });
  },
  // 启用禁用区间
  enableTaskRegion(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/enableTaskRegion",
      data: params,
    });
  },
  // 删除区间
  removeTaskRegion(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/removeTaskRegion",
      data: params,
    });
  },
  //Q-获取区间详情
  getRegionTaskInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/monitor/task/getRegionTaskInfo",
      params,
    });
  },
  // 编辑区间
  updateTaskRegion(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/updateTaskRegion",
      data: params,
    });
  },
  // Q-获取机型列表（已添加、未添加）
  getTaskMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/getTaskMachineList",
      data: params,
    });
  },
  // 批量保存机型（添加，移除）
  handlerTaskMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/monitor/task/handlerTaskMachine",
      data: params,
    });
  },
  // Q-拒绝出价
  examineRejectQuote(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/order/rejectQuote",
      data: params,
    });
  },
  // Q-获取驳回报价原因
  getRejectQuoteCause(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/getRejectQuoteCause",
      params,
    });
  },
  // Q-获取指定机型列表（已添加、未添加）
  getAssignMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/machine/getAssignMachineList",
      data: params,
    });
  },
  // Q-获取lanting已添加机型
  getlantingReferenceMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/indicative/lt/getReferenceMachine",
      data: params,
    });
  },
  // Q-获取lanting全部机型
  getlantingallTaskMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/indicative/lt/getTaskMachineList",
      data: params,
    });
  },
  // Q-修改测算配置
  setlantingConfiguration(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/indicative/setConfiguration",
      data: params,
    });
  },
  // Q-添加移除机型
  addlantingReferenceMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/indicative/lt/addReferenceMachine",
      data: params,
    });
  },
  //出货价增减项-预扣差异-查看金额列表
  getReserveDiffAdjustOptionPriceList(params) {
    return request({
      method: "GET",
      url:
        "/merchant/pc/examine/quote/machine/getReserveDiffAdjustOptionPriceList",
      params,
    });
  },
  // 出货价增减项-预扣差异-保存金额
  saveReserveDiffAdjustOptionPrice(params) {
    return request({
      method: "POST",
      url:
        "/merchant/pc/examine/quote/machine/saveReserveDiffAdjustOptionPrice",
      data: params,
    });
  },
  //分类下拉列表
  examineSelectTypeList(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/machine/selectTypeList",
      params,
    });
  },
  //参考价数据分页获取
  lantingindicativefetch(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/indicative/fetch",
      data: params,
    });
  },
  // Q-处理指定机型（添加，移除）
  handlerAssignMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/handlerAssignMachine",
      data: params,
    });
  },
  // 审单成色设置
  assignOrderHealth(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/examine/quote/user/assignOrderHealth",
      data: params,
    });
  },
  // Q-审单-快捷报价详情
  getExamineOrQuickInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/order/getExamineOrQuickInfo",
      params,
    });
  },
  // 修改别名开关的状态
  healthNicknameUpdate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/MerchantHealthNickname/updateSwitchStatus",
      data: params,
    });
  },
  // 修改别名开关的状态
  updateNickName(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/MerchantHealthNickname/saveOrUpdateNickName",
      data: params,
    });
  },
  // 查询管理成色别名弹窗的详情
  aliasDetail(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/MerchantHealthNickname/selectDetail",
      params,
    });
  },
  //快捷报价配置
  // Q-【报价师等级】获取列表
  getGradeList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/getGradeList",
      data: params,
    });
  },
  // 【报价师等级】添加备注
  saveGradeRemark(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/saveGradeRemark",
      data: params,
    });
  },
  // 【报价师等级】重置配置
  reconfigureGrade(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/reconfigureGrade",
      data: params,
    });
  },
  // 【报价师等级】参考价格必选开关
  isGradeMustChoosePriceButton(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/isGradeMustChoosePriceButton",
      data: params,
    });
  },
  // 【报价师等级】是否展示扣费项
  isGradeShowAdjustClassify(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/isGradeShowAdjustClassify",
      data: params,
    });
  },
  // Q-【报价师等级】查看报价师(已添加-未添加)
  queryGradeQuoterList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/queryGradeQuoterList",
      data: params,
    });
  },
  // 【报价师等级】批量添加-移除报价师
  batchGradeQuoter(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/batchGradeQuoter",
      data: params,
    });
  },
  // Q-【报价师等级】查看报价师机型(已添加-未添加)
  queryGradeQuoterMachineList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/queryGradeQuoterMachineList",
      data: params,
    });
  },
  // 【报价师等级】批量添加-移除报价师机型
  batchGradeQuoterMachine(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/batchGradeQuoterMachine",
      data: params,
    });
  },
  // 【报价师等级】查看报价调整范围
  getQuoteAlterRegion(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/quick/quote/config/getQuoteAlterRegion",
      params,
    });
  },
  // 【报价师等级】设置报价调整范围
  setQuoteAlterRegion(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/setQuoteAlterRegion",
      data: params,
    });
  },
  // 【报价师等级】是否可超限报价
  saveGradeOverLimitQuoteType(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/saveGradeOverLimitQuoteType",
      data: params,
    });
  },
  // 【报价师等级】使用价格类型
  saveGradeUsePriceType(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/config/saveGradeUsePriceType",
      data: params,
    });
  },
  // 查询列表表头功能项
  getAllLowMachineOption(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/merchantAutoQuote/getAllLowMachineOption",
      params: params,
    });
  },
  // 查询低端机报价管理列表
  merchantAutoQuoteList(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/list",
      data: params,
    });
  },
  // 旧机分类列表 /merchantAutoQuote/getAllMachineType-Low
  getAllMachineTypeLow(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/merchantAutoQuote/getAllMachineType-Low",
      params: params,
    });
  },
  // 旧机品牌列表(低端机) /merchantAutoQuote/getOldBrands-low
  getOldBrandsLow(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/merchantAutoQuote/getOldBrands-low",
      params: params,
    });
  },
  // 下拉列表
  selectLowList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/oldMachineType/selectLowList",
      params: params,
    });
  },

  //merchantAutoQuote/changeStatus 单条数据启用/禁用
  changeStatus(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/changeStatus",
      data: params,
    });
  },
  // /merchantAutoQuote/batchEnable 批量启用
  batchEnable(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/batchEnable",
      data: params,
    });
  },
  // /merchantAutoQuote/batchUnEnable 批量禁用
  batchUnEnable(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/batchUnEnable",
      data: params,
    });
  },

  // /merchantAutoQuote/update 单条数据修改价格
  merchantAutoQuoteUpdate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/update",
      data: params,
    });
  },
  // /merchantAutoQuote/update 单条数据修改价格
  excelMachinePrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/excelMachinePrice",
      data: params,
    });
  },
  // /merchantAutoQuote/getPriceRecord 获取报价记录
  getPriceRecord(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/getPriceRecord",
      data: params,
    });
  },
  //导入-机型价格表
  importMachinePrice(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/importMachinePrice",
      data: params,
    });
  },
  //批量修改价格
  batchUpdate(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/merchantAutoQuote/batchUpdate",
      data: params,
    });
  },
  //删除审单人员
  deleteUserInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/examine/quote/user/deleteUserInfo",
      params: params,
    });
  },
  //自动报价订单列表
  list(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/auto/list",
      data: params,
    });
  },
  //自动报价-导出
  excel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/auto/excel",
      data: params,
      responseType: "blob",
    });
  },
  //自动报价-故障下拉
  getFailureType(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/auto/getFailureType",
      params: params,
    });
  },
  //自动报价-报价信息
  autoQuoteInfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/auto/autoQuoteInfo",
      params: params,
    });
  },
  //ai识图
  queryAIIdentify(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/auto/queryAIIdentify",
      params: params,
    });
  },
  queryFinenessHealthCode(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/auto/queryFinenessHealthCode",
      params: params,
    });
  },
  //识图标签下拉
  tagselected(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/ai/identify/tag/selected",
      params,
    });
  },
  //sku对比详情
  skuinfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/auto/sku-info",
      params,
    });
  },
  //开机亮屏照
  //sku对比详情
  screeninfo(params) {
    return request({
      method: "GET",
      url: "/merchant/pc/order/auto/light-screen-info",
      params,
    });
  },
  //等级下拉列表
  healthlist(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/order/auto/health-list",
      data: params,
    });
  },
};
export default menu;
